import ImmunizationHepBView from "./ImmunizationHepBView";

export default ImmunizationHepBView;
